import React from 'react';

import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';

interface TopOptionsProps {
  label: string;
  searchField: string;
  setSearchField: (val: string) => void;
  onOpen: () => void;
}

const TopOptions = ({ label, searchField, setSearchField, onOpen }: TopOptionsProps) => {
  return (
    <Row widths={['fill', 'fit']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField value={searchField} onChange={setSearchField} placeholder="Search for..." onSubmit={() => {}} />
      </Row>

      <Button onClick={onOpen}>{`Add New ${label}`}</Button>
    </Row>
  );
};

export default TopOptions;
